import { getSearch } from 'connected-react-router';
import * as queryString from 'query-string';
import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import { NeighborsProductsModel } from '../../../../models/products.model';
import { updateQueryString } from '../../../../providers/location.provider';
import { updateCoordinateData } from '../../../../store/location';
import { AppState } from '../../../../store/store';
import { LOCATION_PATH } from '../../Navigator';

const SuggestProduct: FC<NeighborsProductsModel> = ({ pictureurl, description, title, locationparameter }) => {
    const dispatch = useDispatch();
    const searchState = useSelector((state: AppState) => getSearch(state));

    if (title && pictureurl && locationparameter) {
        const searchParams: queryString.ParsedQuery = queryString.parse(locationparameter, { arrayFormat: 'comma' });
        const search = updateQueryString(searchState, searchParams as Record<string, string | string[] | number>);

        return (
            <div className={'suggest-product'}>
                <img src={`${pictureurl}&resolution=preview`} alt="Product image" />

                <Link
                    to={{ pathname: LOCATION_PATH, search }}
                    onClick={() => {
                        window.scrollTo(0, 0);
                        dispatch(updateCoordinateData(searchParams));
                    }}
                    className="red-link"
                >
                    <h4>{title}</h4>
                </Link>

                <p dangerouslySetInnerHTML={{ __html: description }} />
            </div>
        );
    }

    return null;
};

export default SuggestProduct;
